import { createFileRoute } from "@tanstack/react-router";
import type { QueryClient } from "@tanstack/react-query";
import { unwrapPageInitialData } from "~/app/api/pageData";
import { digitalServicePageQueryOptions } from "~/app/api/pageData/digitalServicePageQuery";

function DigitalServiceRoute() {
  return null;
}

export async function loadDigitalServicePageData(context: { queryClient: QueryClient }) {
  const result = await context.queryClient.ensureQueryData(digitalServicePageQueryOptions());

  return unwrapPageInitialData(result);
}

export const Route = createFileRoute("/digitalService")({
  loader: async ({ context }) => loadDigitalServicePageData(context),
  component: DigitalServiceRoute,
});
